import { useEffect, useState } from "react";
import useSecStackActions from "../../../hooks/actions/sec-stack.actions";

const PreviewReport = ({ offsetTop = "", mspId, reportId, linkId }) => {
  const [error, setError] = useState(false);
  const [previewHTML, setPreviewHTML] = useState('');
  const [loading, setLoading] = useState(false);
  const { getSecStackReport, getSecStackReportByLinkId } = useSecStackActions();

  useEffect(() => {
    const handleHTML = async () => {
      try {
        setLoading(true);
        const html = linkId ? await getSecStackReportByLinkId(encodeURIComponent(linkId)) : await getSecStackReport(mspId, reportId);
        const hiddenScrollbarHTML = `
          <style>
            ::-webkit-scrollbar {
              display: none;
            }
            ${offsetTop && `
              .page-container {
                margin: ${offsetTop} 0;
              }
            `}
          </style>
          ${html}
        `;
        setPreviewHTML(hiddenScrollbarHTML);
      } catch (err) {
        console.log('err', err)
        setError(err?.message);
      } finally {
        setLoading(false);
      }
    };
    handleHTML();
  }, [mspId, reportId, offsetTop, linkId]);


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center w-100 h-100 f-18">
        <p>Loading report...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center w-100 h-100 f-18">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <iframe
      srcDoc={previewHTML}
      style={{
        width: '1190px',
        height: '100%',
        border: 'none',
        overflow: 'hidden',
      }}
      title="Security Stack Report Preview"
      height="100%"
    />
  )
}

export default PreviewReport;
